import {fillFormInputs, handleApiForm} from "../../../forms";
import {closeModal, openModal} from "../../../utilities";
import * as $ from "jquery";
import {toastAlert} from "../../../toastAlert";
import Spinner from "../../../spinner";
import axios from "axios";
import {confirmModal} from "../../../confirmModal";

export const financial_obligation_types_page = () => {
    const table = $('[data-app-financial_obligation_types="table"]');
    const tableApi = table.DataTable().api();
    const body = $('body');

    let obligation_type_values = JSON.parse(window._obligation_type_values ?? []);

    /// Forms
    // Add type

    function formatDate(dateString) {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;  // Format as dd/mm/yyyy
    }

    handleApiForm('#addFinancialObligationType', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addFinancialObligationTypeModal');
            fillFormInputs(form, {
                name: '',
                default_amount: '',
                obligation_type: 0,
                default_payment_date: '',
                deadline_date : '',
                is_enabled: 1
            })


            let type = response.data.financialObligationType;
            let row = $(`
                <tr data-app-id="${type.id}">
                    <td>${type.name}</td>
                    <td>${obligation_type_values[type.obligation_type].text}</td>
                    <td>${type.default_amount ? type.default_amount : '-'}</td>
                    <td>${type.default_payment_date ? type.default_payment_date : '-'}</td>
                    <td>${type.deadline_date ? formatDate(type.deadline_date) : '-'} </td>
                    <td>${parseInt(type.is_enabled) === 1 ? 'TAK' : 'NIE'}</td>
                    <td>
                        <button data-app-id="${type.id}" type="button" class="btn btn-sm btn-primary btnEditFinancialObligationType">
                            Edytuj
                        </button>
                        <button data-app-id="${type.id}" type="button" class="btn btn-sm btn-danger btnDeleteFinancialObligationType">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            tableApi.rows.add(row);
            tableApi.draw();

            toastAlert('Pomyślnie dodano nowy typ zobowiązania');
        }
    })

    // Edit type
    // load data
    let currentTypeId = null;

    body.on('click', '.btnAddFinancialObligationType', async function(){
        const obligationTypeSelect = document.querySelector('select#addFinancialObligationType_obligation_type');
        const typeCashDiv = document.querySelector('.type_cash_add');
        const typeCashInput = document.querySelector('input[name="default_payment_date"]');
        const typeHoursDiv = document.querySelector('.type_hours_add');
        const typeHoursInput = document.querySelector('input[name="deadline_date"]');
        const defaultAmountLabel = document.querySelector('label[for="default_amount"]');

        function handleObligationTypeChange() {
            const selectedValue = obligationTypeSelect.value;
            if (selectedValue === '1') {
                typeCashDiv.style.display = 'block';
                typeHoursDiv.style.display = 'none';
                clearField(typeHoursInput);
                defaultAmountLabel.textContent = 'Domyślna kwota';
            } else if (selectedValue === '2') {
                typeCashDiv.style.display = 'none';
                clearField(typeCashInput);
                typeHoursDiv.style.display = 'block';
                defaultAmountLabel.textContent = 'Domyślna ilość';
            } else {
                typeCashDiv.style.display = 'none';
                typeHoursDiv.style.display = 'none';
                defaultAmountLabel.textContent = 'Domyślna kwota';
            }
        }

        function clearField(inputElement) {
            if (inputElement) {
                inputElement.value = '';
            }
        }
        handleObligationTypeChange();

        obligationTypeSelect.addEventListener('change', handleObligationTypeChange);
    })


    body.on('click', '.btnEditFinancialObligationType', async function() {
        const spinner = new Spinner();
        currentTypeId = $(this).data('app-id');

        const form = $('#editFinancialObligationType');

        const obligationTypeSelect = document.querySelector('select#editFinancialObligationType_obligation_type');
        const typeCashDiv = document.querySelector('.type_cash_edit');
        const typeHoursDiv = document.querySelector('.type_hours_edit');
        const defaultAmountLabel = document.getElementById('edit_default_amount_label');

        try {
            const response = await axios.get(window.GET_FINANCIAL_OBLIGATION_TYPE_URL.replace('ID', currentTypeId));

            if (response.data.code !== 200) {
                if (response.data.errors) {
                    throw new Error();
                }

                return;
            }

            openModal('#editFinancialObligationTypeModal')
            fillFormInputs(form, response.data.financialObligationType);
            fillFormInputs(form, {
                name: response.data.financialObligationType.name,
                obligation_type: response.data.financialObligationType.obligation_type,
                default_amount: response.data.financialObligationType.default_amount,
                default_payment_date: response.data.financialObligationType.default_payment_date,
                deadline_date : formatDate(response.data.financialObligationType.deadline_date),
                is_enabled: response.data.financialObligationType.is_enabled
            })

            const selectedValue = obligationTypeSelect.value;
            obligationTypeSelect.disabled = true;

            if (selectedValue === '1') {
                typeCashDiv.style.display = 'block';
                typeHoursDiv.style.display = 'none';
                defaultAmountLabel.textContent = 'Domyślna kwota';
            } else if (selectedValue === '2') {
                typeCashDiv.style.display = 'none';
                typeHoursDiv.style.display = 'block';
                defaultAmountLabel.textContent = 'Domyślna ilość';
            } else {
                typeCashDiv.style.display = 'none';
                typeHoursDiv.style.display = 'none';
                defaultAmountLabel.textContent = 'Domyślna kwota';
            }

        } catch(err) {
            toastAlert('Nie udało się załadować danych', {type: 'danger'})
        } finally {
            spinner.destroy()
        }
    })

    // handle form

    handleApiForm('#editFinancialObligationType', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editFinancialObligationTypeModal');
            fillFormInputs(form, {
                name: '',
                obligation_type: 0,
                default_amount: '',
                default_payment_date: '',
                deadline_date : '',
                is_enabled: 1
            })

            const type = response.data.financialObligationType;

            let row = tableApi.$(`tr[data-app-id="${response.data.oldId}"]`);
            row.find(`td:nth-of-type(1)`).text(type.name);
            row.find(`td:nth-of-type(2)`).text(obligation_type_values[type.obligation_type].text);
            row.find(`td:nth-of-type(3)`).text(type.default_amount ? type.default_amount : '-');
            row.find(`td:nth-of-type(4)`).text(type.default_payment_date ? type.default_payment_date : '-');
            row.find(`td:nth-of-type(5)`).text(type.deadline_date ? formatDate(type.deadline_date) : '-');
            row.find(`td:nth-of-type(6)`).text(parseInt(type.is_enabled) === 1 ? 'TAK' : 'NIE');
            tableApi.row(row).invalidate();
            tableApi.draw();

            toastAlert('Pomyślnie zaktualizowano typ zobowiązania');
        }
    }, (form) => {
        form.attr('action', window.FINANCIAL_OBLIGATION_TYPE_EDIT_URL.replace('ID', currentTypeId))
    })

    // Delete type

    body.on('click', '.btnDeleteFinancialObligationType', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten typ zobowiązania?', {color: 'danger'});
        if (!confirm) return;

        try {
            let url = window.FINANCIAL_OBLIGATION_TYPE_DELETE_URL.replace('ID', $(this).data('app-id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.errors);
                err.code = response.data.code;

                throw err;
            }

            let row = tableApi.$(`tr[data-app-id=${$(this).data('app-id')}]`)
            tableApi.row(row).remove().draw();

            toastAlert('Pomyślnie usunięto typ zobowiązania');
        } catch (err) {
            if(err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby usunięcia typu zobowiązania', {type: 'danger'})
        }
    })



}